import {useDebugValue} from 'react';

import classNames from 'classnames';
import {useSearchFormContext} from '../../../hooks/useSearchFormContext';

const classNamespace = 'search-form';
const fieldsClassName = `${classNamespace}__fields`;
const summaryFieldsClassName = `${classNamespace}__summary-fields`;

function useComponent() {
    const {formOptions} = useSearchFormContext();
    const className = classNames(fieldsClassName, summaryFieldsClassName);
    const {isCollapsedSearchformCTA} = formOptions;

    const result = {
        className,
        isCollapsedSearchformCTA
    };

    useDebugValue(result);

    return result;
}

export {useComponent};
